import React from "react";
import { useT } from "../../lib/lang";

// Iter96 — Phase 2B live measurement readout (spec §6/§7: "zone lisible,
// sans masquer excessivement la carte"). Purely presentational — all
// numbers are computed by the caller (PlanificationTab) from the
// CURRENT geometry via Turf on every Terra Draw `change` event, never
// from a stale/cached display value (spec §6: "recalculables à partir
// de la géométrie, sans dépendre d'une valeur d'affichage devenue
// obsolète").
//
// `kind`: "line" -> segment + total distance; "polygon" -> area only.
export const PlanificationMeasureReadout = ({ kind, segmentLabel, totalLabel, areaLabel }) => {
  const [t] = useT();
  if (!kind) return null;
  return (
    <div
      className="absolute top-3 left-1/2 -translate-x-1/2 z-[460] flex items-center gap-3 bg-[#111418]/90 backdrop-blur border border-zinc-800 px-3 py-1.5 text-[11px] font-mono text-zinc-200 pointer-events-none"
      data-testid="planification-measure-readout"
    >
      {kind === "line" ? (
        <>
          <span data-testid="planification-readout-segment">
            <span className="text-zinc-500">{t.planificationSegmentDistance}: </span>{segmentLabel}
          </span>
          <span className="text-zinc-700">|</span>
          <span data-testid="planification-readout-total">
            <span className="text-zinc-500">{t.planificationTotalDistance}: </span>
            <span className="text-emerald-300 font-semibold">{totalLabel}</span>
          </span>
        </>
      ) : (
        <span data-testid="planification-readout-area">
          <span className="text-zinc-500">{t.planificationArea}: </span>
          <span className="text-emerald-300 font-semibold">{areaLabel}</span>
        </span>
      )}
    </div>
  );
};
